











































import { PropType, defineComponent } from 'vue'
import { Receita } from '~/store/docs';
import DialogModal from '~/components/DialogModal.vue';
import { doc_linha_sevice } from '~/store/docs';
import Swal from 'sweetalert2';

export default defineComponent({
    props: {
        receitas: {
            type: Array as PropType<Receita[]>
        },
        codigo: {
            type: String
        }
    },
    components: {
        DialogModal
    },
    data() {
        return {
            salvando: false,
            valor: '0,00',
            complemento: '',
            codigo_receita: 0
        }
    },
    methods: {
        async save() {
            try {
                this.salvando = true
                let response = await doc_linha_sevice.incluir({                    
                    complemento: this.complemento,
                    valor: Number(this.valor.replace(/\D+/igm, '')) / 100,
                    codigo_doc: Number(this.codigo),
                    codigo_receita: this.codigo_receita
                })

                this.$emit('updated', response.linhas)
                await Swal.fire({
                    target: `.dialog-nova-linha`,
                    icon: 'success',
                    title: "Registro inserido com sucesso"
                })

                this.onClose()
                
            } catch (error) {
                let text = 'Não foi possível salvar o registro'
                if (error instanceof Error) {
                    text = error.message
                }
                await Swal.fire({
                    target: `.dialog-nova-linha`,
                    icon: 'error',
                    title: "Oops",
                    text
                })
            }
            this.salvando = false
        },
        onClose() {
            this.$router.back()
        }
    },
    watch: {
        valor(value) {
            
            this.valor = (value.replace(/\D+/igm, '') / 100).toLocaleString('pt-br', {
                minimumFractionDigits: 2
            })
        }
    }
})

